"use client";
import React from "react";
import dynamic from "next/dynamic";
const FavoriteButton = dynamic(() => import("../controls/favorite-button"), { ssr: false });
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

const CollectionListItemClient = ({
    productHandle,
    refresh,
}: {
    productHandle: string;
    refresh: boolean | undefined;
}) => {
    const { hasMouseMoved } = useMouseMovement();

    return (
        <>
            {hasMouseMoved && (
                <FavoriteButton
                    className="w-10 h-10 absolute sm:top-4 sm:right-4 top-3 right-3 bg-white"
                    productHandle={productHandle}
                    refresh={refresh}
                />
            )}
        </>
    );
};

export default CollectionListItemClient;
